import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | WINTRUST SOLUTIONS - Tax Consultant in Coimbatore</title>
        <meta name="description" content="Read the Privacy Policy for WINTRUST SOLUTIONS. Learn how we collect, use, and protect your personal information when you use our tax consultancy services in Coimbatore." />
      </Helmet>

      <section className="bg-navy py-12">
        <div className="container-custom">
          <nav className="text-slate-400 text-sm mb-4">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-white">Privacy Policy</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-bold text-white font-heading">
            Privacy Policy
          </h1>
        </div>
      </section>

      <section className="bg-white section-padding">
        <div className="container-custom max-w-4xl">
          <div className="prose prose-slate max-w-none space-y-8">
            <p className="text-slate-600 text-lg">
              At WINTRUST SOLUTIONS, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.
            </p>
            <p className="text-slate-500 text-sm">Last Updated: February 2026</p>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">1. Information We Collect</h2>
              <p className="text-slate-600 mb-3">We may collect the following types of information:</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li><strong>Personal Information:</strong> Name, email address, phone number, business details, and any other information you provide when you fill out our contact form or engage our services.</li>
                <li><strong>Financial Information:</strong> Tax-related documents and financial records you share with us for the purpose of tax filing and compliance services.</li>
                <li><strong>Usage Data:</strong> Information about how you access and use our website, including your IP address, browser type, pages visited, and time spent on pages.</li>
                <li><strong>Cookies:</strong> We use cookies and similar tracking technologies to enhance your browsing experience and analyze website traffic.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">2. How We Use Your Information</h2>
              <p className="text-slate-600 mb-3">We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>Provide, maintain, and improve our tax consultancy and compliance services.</li>
                <li>Respond to your inquiries and provide customer support.</li>
                <li>Process and file your GST returns, ITR, TDS, and other tax-related documents.</li>
                <li>Send you updates, newsletters, and promotional communications (with your consent).</li>
                <li>Analyze website usage to improve user experience and service quality.</li>
                <li>Comply with legal obligations and regulatory requirements.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">3. How We Protect Your Information</h2>
              <p className="text-slate-600">
                We implement robust security measures to protect your personal and financial information. All data transmitted through our website is encrypted using industry-standard SSL/TLS encryption. We restrict access to your personal information to authorized employees and service providers who need it to perform their duties. We regularly review and update our security practices to ensure the safety of your data.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">4. Information Sharing</h2>
              <p className="text-slate-600 mb-3">We do not sell, trade, or otherwise transfer your personal information to third parties except in the following circumstances:</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li><strong>Service Providers:</strong> We may share your information with trusted third-party service providers who assist us in operating our website and delivering our services (e.g., hosting providers, analytics tools).</li>
                <li><strong>Government Authorities:</strong> We may disclose your information to government tax authorities (such as the GST portal or Income Tax Department) as required for filing your returns and compliance.</li>
                <li><strong>Legal Requirements:</strong> We may disclose your information if required by law, regulation, or legal process.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">5. Cookies</h2>
              <p className="text-slate-600">
                Our website uses cookies to improve your browsing experience. Cookies are small files placed on your device that help us understand how you use our site. You can choose to disable cookies through your browser settings, but this may affect the functionality of our website. We use Google Analytics to track and analyze website traffic, and it may place its own cookies on your device.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">6. Your Rights</h2>
              <p className="text-slate-600 mb-3">You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2 text-slate-600">
                <li>Access the personal information we hold about you.</li>
                <li>Request correction of any inaccurate or incomplete information.</li>
                <li>Request deletion of your personal information (subject to legal obligations).</li>
                <li>Opt out of receiving promotional communications from us.</li>
                <li>Withdraw your consent for data processing at any time.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">7. Data Retention</h2>
              <p className="text-slate-600">
                We retain your personal information for as long as necessary to fulfill the purposes outlined in this policy, or as required by applicable laws and regulations. Tax-related documents and records are retained for the period mandated by Indian tax laws (typically 6-8 years from the end of the relevant assessment year).
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">8. Changes to This Policy</h2>
              <p className="text-slate-600">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this policy periodically.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-navy font-heading mb-3">9. Contact Us</h2>
              <p className="text-slate-600">
                If you have any questions or concerns about this Privacy Policy, please contact us:
              </p>
              <div className="bg-slate-50 p-6 rounded-lg mt-4 space-y-2 text-slate-600">
                <p><strong>WINTRUST SOLUTIONS</strong></p>
                <p>Email: wintrustsolutions@gmail.com</p>
                <p>Phone: +91 89409 88776</p>
                <p>Location: Coimbatore, Tamil Nadu, India</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicyPage;
